'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var NonPreviewDefaultComponent = function NonPreviewDefaultComponent(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === undefined ? "No Preview" : _ref$title,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? null : _ref$size,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? null : _ref$type;
  return _react2.default.createElement('div', {
    style: {
      backgroundColor: '#FFFFFF',
      height: '30vmin',
      width: '30vmin',
      marginTop: 5,
      marginBottom: 5,
      marginRight: 5,
      boxShadow: "rgba(0, 0, 0, 0.188235) 0px 10px 30px, rgba(0, 0, 0, 0.227451) 0px 6px 10px",
      overflow: 'hidden'
    }
  }, _react2.default.createElement('div', {
    style: {
      margin: 5
    }
  }, _react2.default.createElement('p', {
    style: {
      margin: 0,
      fontWeight: '500'
    }
  }, title.split('.')[0]), _react2.default.createElement('p', {
    style: {
      margin: 0
    }
  }, size + " kb"), _react2.default.createElement('p', {
    style: {
      margin: 0
    }
  }, type !== "" ? type.split('/')[1] : title.split('.')[1])));
};

exports.default = NonPreviewDefaultComponent;